<template>
    <div class="mx-auto">
        <p class="mb-2"><b>Informe o Devedor:</b>
            <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
               v-b-modal.modal-info-devedor></i>
        </p>

        <b-row v-if="devedores == null">
            <b-col md="2">
                <b-form-group
                        label="Número do CPF / CNPJ:"
                        label-for="cpf"
                        class="text-label"
                        :description="validations.cpf.valid ? 'Somente os números' : ''">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            :disabled="requisicao.numeroCda != null && requisicao.numeroCda != ''"
                            v-model="requisicao.devedor.documento"
                            v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                            @change="buscarDevedor();"
                            @keydown.tab.prevent="validarTabDevedor();"
                            :class="'cpfCnpj ' + (!validations.cpf.valid ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-if="!validations.cpf.valid && validations.cpf.invalidDocument" class="invalid-message">Documento inválido!</span>
                    <span v-if="!validations.cpf.valid && validations.cpf.semCarta" class="invalid-message">Não consta(m) protesto(s) ativo(s) e sem carta de cancelamento para o Devedor informado!</span>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label">
                    <b-form-input
                            v-if="requisicao.devedor.codContribuinte != null"
                            type="text"
                            id="devedor"
                            v-model="requisicao.devedor.nome"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                    <b-form-input
                            v-if="requisicao.devedor.codContribuinte == null"
                            type="text"
                            id="devedor"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        tabindex="-1"
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        :disabled="!validations.cpf.valid || (requisicao.devedor.documento == null || requisicao.devedor.documento == '')"
                        @click="abrirModalDevedor(requisicao.devedor, false)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
                <b-button
                        tabindex="-1"
                        class="icon-button btn-documentos"
                        title="Documentação do Devedor"
                        variant="outline-primary"
                        :disabled="requisicao.devedor.documento == null 
                                   || requisicao.devedor.documento == ''
                                   || requisicao.devedor.documento.length < 14
                                   || (requisicao.devedor.documento.length == 14 && !validations.cpf.valid) 
                                   || (requisicao.devedor.documento.length == 18 && !this.validarCnpjAlfanumerico(requisicao.devedor.documento))"
                        @click="abrirModalDocumentosDevedor()">
                    <i class="far fa-copy fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <b-row v-for="devedorLista in devedores">
            <b-col md="2">
                <b-form-group
                        label="Número do CPF / CNPJ:"
                        label-for="cpf"
                        class="text-label">
                    <b-input-group>
                        <b-input-group-append>
                            <b-form-radio name="radioDevedor" v-model="radioDevedor" :value="devedorLista.documento" @change="atribuirDevedorRadio(devedorLista)"></b-form-radio>
                        </b-input-group-append>
                        <b-form-input
                                :class="devedorLista.documento == radioDevedor ? 'text-bold' : ''"
                                type="text"
                                id="num-documento"
                                data-vv-as="CPF"
                                :disabled="true"
                                v-model="devedorLista.documento"
                                v-mask="['XX.XXX.XXX', 'XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label">
                    <b-form-input
                            :class="devedorLista.documento == radioDevedor ? 'text-bold' : ''"
                            v-if="devedorLista.codContribuinte != null"
                            type="text"
                            id="devedor"
                            v-model="devedorLista.nome"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                    <b-form-input
                            v-if="devedorLista.codContribuinte == null"
                            type="text"
                            id="devedor"
                            :disabled="true"
                            data-vv-as="devedor"
                            description="Devedor"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="2" class="mt-4" style="margin-left: -15px;">
                <b-button
                        tabindex="-1"
                        class="icon-button"
                        title="Abrir Cadastro do Devedor"
                        variant="outline-primary"
                        :disabled="radioDevedor != devedorLista.documento"
                        @click="abrirModalDevedor(devedorLista, true)">
                    <i class="far fa-address-book fa-flip-horizontal vertical-middle"></i>
                </b-button>
            </b-col>
        </b-row>

        <hr>

        <p class="mb-2"><b>Informe o Número da CDA:</b>
            <i class="fas fa-info-circle text-info fa-12x ml-3" variant="info"
               tabindex="-1"
               v-b-modal.modal-info-cda></i>
        </p>
        <b-row>
            <b-col md="2">
                <b-form-group
                        :description="validations.cda.valid ? 'Somente os números' : ''">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            v-model="requisicao.numeroCda"
                            v-mask="['###########']"
                            @change="buscarCda();"
                            @focus="changeFocus();"
                            :class="'cda ' + (!validations.cda.valid ? 'is-invalid' : '')"
                    ></b-form-input>
                    <span v-if="!validations.cda.valid && validations.cda.existente" class="invalid-message">CDA inexistente no PROAJU!</span>
                    <span v-if="!validations.cda.valid && validations.cda.carta" class="invalid-message">Não consta protesto ativo e sem carta de cancelamento para a CDA informada!</span>
                </b-form-group>
            </b-col>
        </b-row>

        <b-modal
                ref="modal-info-devedor"
                id="modal-info-devedor"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Gerar Requisição a partir de um CPF/CNPJ"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Exibirá todos os registros de protesto ativo e sem carta de cancelamento emitida para o devedor informado pelo CPF, CNPJ ou CNPJ raiz.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-devedor')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-info-cda"
                id="modal-info-cda"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Gerar Requisição a partir de uma CDA"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <ul>
                        <li>
                            <p>Exibirá eventual(is) protesto(s) ativo(s) e sem carta de cancelamento emitida para a CDA informada.</p>
                        </li>
                    </ul>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-info-cda')"> Fechar</b-button>
            </template>
        </b-modal>

        <CompLoading ref="loadingDevedor"/>
        <ModalIncluirDevedor ref="modalDevedor"
                             @novoDevedor="salvarDevedor"
                             @cancelarNovoDevedor="mudarFocusCpf" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loadingDevedor"
                @salvarDevedor="salvarDevedor"/>

	    <ModalDocumentosDevedor ref="modalDocumentosDevedor"
	                            :loading="$refs.loadingDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import CompLoading from "../../shared/components/CompLoading";
    import ModalDocumentosDevedor from "../../shared/components/ModalDocumentosDevedor";

    export default {
        props: ['requisicao'],
        mixins: [ formatarMixins ],
        components: {ModalDocumentosDevedor, ModalIncluirDevedor, ModalAlterarDevedor, CompLoading},
        data() {
            return {
                urlApi: null,
                devedores: null,
                devedorAtual: null,
                radioDevedor: null,
                validations: {
                    cpf: {
                        valid: true,
                        invalidDocument: false,
                        semCarta: false
                    },
                    cda: {
                        valid: true,
                        existente: false,
                        carta: false
                    }
                }
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            async buscarDevedor() {
                this.validations.cpf.valid = true;
                this.validations.cpf.invalidDocument = false;
                this.validations.cpf.semCarta = false;
                if(this.requisicao.devedor.documento == null || this.requisicao.devedor.documento == "") {
                    this.atribuirDevedor(null);
                    return;
                }

                if(this.requisicao.devedor.documento.length < 10 || (this.requisicao.devedor.documento.length > 10 && this.requisicao.devedor.documento.length <= 14 && !this.validarCpf(this.requisicao.devedor.documento))
                    || (this.requisicao.devedor.documento.length > 14 && !this.validarCnpjAlfanumerico(this.requisicao.devedor.documento))) {
                    this.validations.cpf.valid = false;
                    this.validations.cpf.invalidDocument = true;
                    this.requisicao.devedor.nome = "";
                    this.mudarFocusCpf();
                    return;
                }

                let devedor = {
                    documento: this.requisicao.devedor.documento
                };

                this.$refs.loadingDevedor.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosProtesto/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        let devedorRetorno = response.data;
                        devedorRetorno.documento = this.requisicao.devedor.documento;
                        this.atribuirDevedor(devedorRetorno);

                        setTimeout(()=>{
                            if(this.requisicao.devedor.codContribuinte == null) {
                                this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.requisicao.devedor);
                            }
                        }, 200);
                    } else {
                        this.requisicao.devedor.nome = null;
                        this.validations.cpf.valid = false;
                        this.validations.cpf.semCarta = true;
                    }
                }).finally(() => {
                    this.$refs.loadingDevedor.hideLoading();
                })
            },
            validarTabDevedor() {
                if(this.requisicao.devedor.documento == null || this.requisicao.devedor.documento == "") {
                    document.getElementsByClassName('cda')[0].focus();
                } else {
                    this.buscarDevedor();
                }
            },
            changeFocus() {
                if(this.requisicao.numeroCda == "" || this.requisicao.numeroCda == null) {
                    this.atribuirDevedor(null);
                    this.validations.cpf.valid = true;
                    this.validations.cpf.invalidDocument = false;
                    this.validations.cpf.semCarta = false;
                }
            },
            async buscarCda() {
                this.$store.commit("setMessages", {});

                this.atribuirDevedor(null);
                this.devedorAtual = null;
                this.radioDevedor = null;
                this.validations.cda.valid = true;
                this.validations.cda.carta = false;
                this.validations.cda.existente = false;
                if(this.requisicao.numeroCda == "" || this.requisicao.numeroCda == null) {
                    this.devedores = null;
                    return;
                }

                this.$refs.loadingDevedor.showLoading();
                axios.get(`${this.urlApi}/v1/honorariosProtesto/obterContribuintes/${this.requisicao.numeroCda}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.devedores = null;
                    if(response.data == null || response.data.length <= 0) {
                        this.validations.cda.valid = false;
                        this.validations.cda.carta = true;
                        this.devedores = null;
                    } else {
                        if(response.data.length == 1) {
                            this.atribuirDevedor(response.data[0]);
                        } else {
                            this.devedores = response.data;
                        }
                    }
                }).catch((error) => {
                    if (error.response !== undefined && error.response.status === 404) {
                        this.validations.cda.valid = false;
                        this.validations.cda.existente = true;
                        this.devedores = null;
                    } else {
                        this.exibirErro(error);
                    }
                }).finally(() => {
                    this.$refs.loadingDevedor.hideLoading();
                })
            },
            abrirModalDevedor(devedor, devedorLista) {
                if(devedorLista) {
                    this.devedorAtual = devedor;
                } else {
                    this.devedorAtual = null;
                }

                if(devedor.codContribuinte != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(devedor.codContribuinte);
                } else {
                    this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(devedor);
                }
            },
            salvarDevedor(contribuinte) {
                if(this.devedorAtual != null) {
                    let listaDevedores = [];
                    for(let i = 0; i < this.devedores.length; i++) {
                        if(this.devedores[i].documento == contribuinte.documento) {
                            listaDevedores.push(contribuinte);
                        } else {
                            listaDevedores.push(this.devedores[i]);
                        }
                    }
                    this.devedores = listaDevedores;
                }
                this.atribuirDevedor(contribuinte);
            },
            atribuirDevedor(contribuinte) {
                this.$emit('atribuirDevedor', contribuinte);

                if(contribuinte != null && contribuinte.codContribuinte == null) {
                    setTimeout(()=>{
                        if(this.requisicao.devedor.codContribuinte == null) {
                            this.$refs.modalDevedor.abrirModalIncluirDevedorComDados(this.requisicao.devedor);
                        }
                    }, 200);
                }
            },
            atribuirDevedorRadio(contribuinte) {
                this.$emit('atribuirDevedor', contribuinte);

                if(contribuinte.codContribuinte == null) {
                    this.abrirModalDevedor(contribuinte, true);
                }
            },
            validarForm() {
                return this.validations.cpf.valid && this.validations.cda.valid
                    && this.requisicao.devedor.codContribuinte != null
                    && !this.$refs.modalDevedor.isShow()
                    && !this.$refs.modalAlterarDevedor.isShow()
	                && !this.$refs.modalDocumentosDevedor.isShow();
            },
            mudarFocusCpf() {
                document.getElementsByClassName('cpfCnpj')[0].focus();
            },
            modalOpen() {
                return this.$refs.modalDevedor.isShow() || this.$refs.modalAlterarDevedor.isShow() || this.$refs.modalDocumentosDevedor.isShow();
            },

	        abrirModalDocumentosDevedor () {
		        document.activeElement.blur();
		        this.$refs['modalDocumentosDevedor'].abrirModal(this.requisicao.devedor.documento, this.requisicao.devedor.codContribuinte);
	        },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;
        }
    }
</script>

<style scoped>
    .icon-button {
        font-size: 1.5rem;
        margin-left: 1rem;
        padding: 0 0.5rem;
    }

    .vertical-middle {
        vertical-align: middle;
    }
</style>
